import { render } from "./Assets_return_button.vue?vue&type=template&id=18f79a62&scoped=true"
import script from "./Assets_return_button.vue?vue&type=script&lang=js"
export * from "./Assets_return_button.vue?vue&type=script&lang=js"

import "./Assets_return_button.vue?vue&type=style&index=0&id=18f79a62&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f79a62"]])

export default __exports__